import React from 'react';
import { InputValueEditor } from './InputValueEditor/InputValueEditor';
import type { DataValue, NodeInstanceDataPort, UserDefinedType } from '@glueapp/graph-types';
import { getDefaultValueForDataType } from '@glueapp/graph-types';
import { Button } from '@/components/ui/button';

interface Props {
    inPort: NodeInstanceDataPort;
    portValue: DataValue | undefined;
    portUserDefinedType: UserDefinedType;
    hasConnection?: boolean;
    onValueChange: (inPort: NodeInstanceDataPort, value: DataValue | undefined, type?: UserDefinedType) => void;
}

const BasePortValueEditor: React.FC<Props> = ({ inPort, portValue, portUserDefinedType, onValueChange, hasConnection = false }) => {
    return (
        <div className="flex flex-col" key={inPort.name}>
            {hasConnection ? (
                <p className="text-xs text-muted-foreground italic">Covered by connection</p>
            ) : inPort.type === undefined || inPort.type === null ? (
                <p className="text-xs text-muted-foreground italic">No type determined for port</p>
            ) : inPort.optional && portValue === undefined ? (
                <Button
                    variant="outline"
                    size="sm"
                    onClick={() => onValueChange(inPort, getDefaultValueForDataType(inPort.type), undefined)}
                >
                    Enable optional port
                </Button>
            ) : (
                <>
                    <InputValueEditor
                        type={inPort.type}
                        value={portValue !== undefined ? portValue : getDefaultValueForDataType(inPort.type)}
                        userDefinedType={portUserDefinedType}
                        onChange={(newValue, newType) => onValueChange(inPort, newValue, newType)}
                    />
                    {inPort.optional ? (
                        <Button variant="outline" size="sm" onClick={() => onValueChange(inPort, undefined, undefined)}>
                            Disable optional port
                        </Button>
                    ) : null}
                </>
            )}
        </div>
    );
};

export const PortValueEditor = React.memo(BasePortValueEditor);
